<template>
  <div class="footer">
    <div class="footer_bot">
      <div class="footer_con">
        <p class="footer_title">联系我们</p>
        <div class="footer_conter">
          <ul>
            <li>咨询热线</li>
            <li>010-6358-5582</li>
          </ul>
          <ul>
            <li><span>企业邮箱</span><span style="display:block; margin-left:36px;">hrzl@ec-power.cn</span></li>
            <li>
              <span>公司地址</span>
              <span style="display:block; margin-left:36px;">北京市西城区白纸坊东街2号经济日报综合楼1406</span>
            </li>
          </ul>
        </div>
        <div class="footer_conter_mo">
          <ul>
            <li>咨询热线</li>
            <li>010-6358-5582</li>
          </ul>
          <ul>
            <li>
              <span>企业邮箱</span>&nbsp;&nbsp;<span>hrzl@ec-power.cn</span>
            </li>
            <li>
              <span>公司地址</span>&nbsp;
              <span>北京市西城区白纸坊东街2号经济日报综合楼1406</span>
            </li>
          </ul>
        </div>
        <div class="er_img">
          <div>
            <p>关注EC POWER公众号</p>
            <p>长按图片可保存二维码</p>
          </div>
          <div style="text-align: end; margin-left: 31%">
            <img class="er_image" src="@/assets/er.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="footer_top">
      <p >
        CopyRight@2018 EC POWER ALL RIGHTS RESERVERD. 
       
      </p>
      <p><span>和瑞众联 版权所有</span><span><a href="https://beian.miit.gov.cn/">京ICP备19022366号-3</a></span></p>
     
    </div>
  </div>
</template>

<script> 
export default {
  name: "feedBack",
};
</script>


<style scoped>
a{
  color:#fff;
}
.footer_con {
  width: 69%;
  height: 100%;
  margin: 0 auto;
}
.footer_title {
  font-size: 26px;
  font-weight: 500;
  color: #ffffff;
  line-height: 26px;
  padding: 64px 0px 31px 0px;
  text-align: start;
}
.footer_conter_mo,
.er_img {
  display: none;
}
.footer_top {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 40px;
  background: #0b0b0b;
}
.footer_top p {
  /* width: 100%; */
  /* margin: 0 auto; */
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  line-height: 40px;
}
/* .footer_top {
  width: 100%;
  height: 40px;
  background: #0b0b0b;
}
.footer_top p {
  width: 100%;
  margin: 0 auto;
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  line-height: 40px;
} */
.footer_bot {
  width: 100%;
  height: 197px;
  /* background: #0b0b0b; */
  background-image: url("https://www.bjecpower.com/img/gw/b05.png");
  box-sizing: border-box;
  background-size: 100%;
  background-repeat: no-repeat;
}
.footer_conter {
  width: 100%;
  display: flex;
}

.footer_conter ul:nth-child(1) {
  text-align: left;
}
.footer_conter ul li{ display:flex;}
.footer_conter ul:nth-child(1) li:nth-child(1) {
  font-size: 18px;
  font-weight: 400;
  color: #ffffff;
  line-height: 13px;
}
.footer_conter ul:nth-child(1) li:nth-child(2) {
  font-size: 18px;
  font-weight: 500;
  color: #ffffff;
  line-height: 18px;
  margin-top: 9px;
}
.footer_conter ul:nth-child(2) {
  margin-left: 8%;
  text-align: left;
}

.footer_conter ul:nth-child(2) li {
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  line-height: 13px;
}

.footer_conter ul:nth-child(2) li:nth-child(2) {
  margin-top: 10px;
}
@media screen and (max-width: 1440px) {
}
@media screen and (max-width: 768px) {
  a{
  color:#9EA5BB;
}
  .footer {
    height: 365px;
    background: #141519;
  }
  .footer_con {
    width: 100%;
  }
  .footer_bot {
    background-image: none;
  }
  .footer_title {
    display: none;
  }
  .footer_conter {
    display: none;
  }
  .footer_conter_mo {
    display: block;
    padding-top: 15px;
  }
  .footer_conter_mo ul:nth-child(1) {
    width: 92%;
    display: flex;
    height: 39px;
    line-height: 40px;
    background: #004e96;
    margin: 10px 15px 24px 15px;
    justify-content: space-around;
  }

  .footer_conter_mo ul:nth-child(1) li:nth-child(1) {
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
    /* line-height: 39px; */
   
  }
  .footer_conter_mo ul:nth-child(1) li:nth-child(2) {
    margin-left: 35%;
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
    /* line-height: 39px; */
    margin-top: 0px;
  }

  .footer_conter_mo ul:nth-child(2) li {
    font-size: 10px;
    font-weight: 400;
    color: #ffffff;
    line-height: 13px;
    text-align: left;
    margin: 8px 0px 0px 15px;
  }

  .er_img {
    display: flex;
    justify-content: space-between;
    width: 92%;
    height: 89px;
    border: 0.5px solid #5b5b5b;
    border-left: none;
    border-right: none;
    margin: 24px 15px 15px 15px;
  }
  .er_img p:nth-child(1) {
    font-size: 14px;
    text-align: left;
    font-weight: 500;
    color: #ffffff;
    line-height: 14px;
    margin: 24px 0px 8px 0px;
  }
  .er_img p:nth-child(2) {
    font-size: 10px;
    text-align: left;
    font-weight: 500;
    color: #9ea5bb;
    line-height: 10px;
  }
  .er_image {
    width: 90px;
    height: 90px;
  }

  .footer_top {
    display:block;
    width: 100%;
    height: 0;
    background: #141519;
    margin-top: 15%;
  }
  .footer_top p {
    margin:0 auto;
    /* width: 86%; */
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-size: 10px;
    font-weight: 400;
    color: #9ea5bb;
    line-height: 15px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue